import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './mijn-start-chat.content.json';

@Component({
    selector: 'mijn-start-chat',
    templateUrl: './mijn-start-chat.component.html',
    standalone: false
})
export class MijnStartChatComponent implements OnInit {
    @Output()
    public openChat = new EventEmitter<void>();

    private readonly contentService = inject(ApContentService);

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public onOpenChat(): void {
        this.openChat.emit();
    }
}
